(() => {
  'use strict';

  if (!/\/apps\/track_order\/?/i.test(window.location.pathname)) return;

  const rootPath = window.Shopify?.routes?.root || '/';
  const storefrontUrl = path => `${rootPath}${String(path || '').replace(/^\/+/, '')}`;

  const i18n = window.EdelmanTrackI18n || {};
  const main = document.getElementById('MainContent');
  if (!main) return;

  document.body.classList.add('ew-track-order-page');

  const clean = (value) => (value || '').replace(/\s+/g, ' ').trim().toLowerCase();
  const textMatches = (element, phrases) => {
    const text = clean(element?.textContent);
    return phrases.some((phrase) => text.includes(clean(phrase)));
  };

  const getRectArea = (element) => {
    const rect = element.getBoundingClientRect();
    return Math.max(0, rect.width) * Math.max(0, rect.height);
  };

  const findSubmit = () => {
    const controls = [...main.querySelectorAll('button, input[type="submit"], [role="button"], a')];
    return controls.find((element) => {
      const label = element.tagName === 'INPUT' ? element.value : element.textContent;
      return /volg uw bestelling|volg je bestelling|track your order|track order|bestelling volgen/i.test(label || '');
    }) || null;
  };

  const findCard = () => {
    const submit = findSubmit();
    const candidates = [...main.querySelectorAll('form, section, article, div')].filter((element) => {
      const inputCount = element.querySelectorAll('input').length;
      if (inputCount < 2) return false;
      if (!element.querySelector('button, input[type="submit"], [role="button"]')) return false;
      const rect = element.getBoundingClientRect();
      return rect.width >= 250 && rect.width <= 760 && rect.height >= 180;
    });

    if (submit) {
      let node = submit.parentElement;
      while (node && node !== main) {
        if (candidates.includes(node)) return node;
        node = node.parentElement;
      }
    }

    const scored = candidates.map((element) => {
      let score = 0;
      const text = clean(element.textContent);
      const rect = element.getBoundingClientRect();
      if (text.includes('track123')) score += 12;
      if (text.includes('bestelnummer')) score += 7;
      if (text.includes('trackingnummer')) score += 7;
      if (text.includes('volg uw bestelling') || text.includes('track your order')) score += 10;
      if (rect.width <= 560) score += 3;
      score -= getRectArea(element) / 1000000;
      return { element, score };
    }).sort((a, b) => b.score - a.score);

    return scored[0]?.element || null;
  };

  const findHero = (card) => {
    if (!card) return null;
    let node = card.parentElement;
    let hero = null;

    while (node && node !== main) {
      const rect = node.getBoundingClientRect();
      const style = window.getComputedStyle(node);
      const wide = rect.width >= Math.min(window.innerWidth * 0.78, 1000);
      const tall = rect.height >= 360;
      const hasBackground = style.backgroundImage && style.backgroundImage !== 'none';
      if ((wide && tall) || hasBackground) hero = node;
      node = node.parentElement;
    }

    return hero || card.parentElement || main.firstElementChild;
  };

  const markTabs = (card) => {
    const tabPhrases = ['Bestelnummer', 'Trackingnummer', 'Order number', 'Tracking number'];
    const tabs = [...card.querySelectorAll('button, [role="tab"], a, div, span')].filter((element) => {
      const ownText = clean(element.textContent);
      if (!ownText || ownText.length > 40) return false;
      return tabPhrases.some((phrase) => ownText === clean(phrase));
    });

    tabs.forEach((tab) => tab.classList.add('ew-track123-tab'));

    if (tabs.length >= 2) {
      const parentCounts = new Map();
      tabs.forEach((tab) => {
        const parent = tab.parentElement;
        if (parent) parentCounts.set(parent, (parentCounts.get(parent) || 0) + 1);
      });
      const row = [...parentCounts.entries()].sort((a, b) => b[1] - a[1])[0]?.[0];
      if (row) row.classList.add('ew-track123-tab-row');
    }

    const selected = tabs.find((tab) => tab.getAttribute('aria-selected') === 'true');
    tabs.forEach(tab => tab.classList.toggle('ew-track123-tab--active', tab === (selected || tabs[0])));
    tabs.forEach(tab => { if (tab.dataset.ewTabBound) return; tab.dataset.ewTabBound='true'; tab.addEventListener('click', () => tabs.forEach(other => other.classList.toggle('ew-track123-tab--active', other === tab))); });
  };

  const markElements = (card) => {
    card.classList.add('ew-track123-card');

    const submit = findSubmit();
    if (submit && card.contains(submit)) submit.classList.add('ew-track123-submit');

    [...card.querySelectorAll('*')].forEach((element) => {
      const text = clean(element.textContent);
      if (text && text.length < 80 && text.includes('powered by track123')) {
        element.classList.add('ew-track123-powered');
      }
    });

    markTabs(card);
  };

  const createIntro = () => {
    const intro = document.createElement('div');
    intro.className = 'ew-track123-intro';
    intro.innerHTML = `
      <p class="ew-track123-eyebrow">Edelman Watches</p>
      <h1>${i18n.heading}</h1>
      <p>${i18n.intro}</p>
      <div class="ew-track123-benefits">
        <div class="ew-track123-benefit"><strong>${i18n.statusTitle}</strong><span>${i18n.statusText}</span></div>
        <div class="ew-track123-benefit"><strong>${i18n.secureTitle}</strong><span>${i18n.secureText}</span></div>
        <div class="ew-track123-benefit"><strong>${i18n.helpTitle}</strong><span>${i18n.helpText}</span></div>
      </div>`;
    return intro;
  };


  const findResultRoot = (card) => {
    const keywords = [
      'pakketinformatie',
      'pakketinhoud',
      'verzendgegevens',
      'vervoerder',
      'bestelling gereed',
      'geleverd',
      'transit',
      'tracking details',
      'shipment information'
    ];

    const candidates = [...main.querySelectorAll('section, article, div')].filter((element) => {
      if (!element || element === card || card.contains(element)) return false;
      if (element.classList.contains('ew-track123-aftercare')) return false;
      if (element.querySelector('input, textarea, select')) return false;
      const text = clean(element.textContent);
      if (!text || text.length < 30) return false;
      const matches = keywords.filter((keyword) => text.includes(keyword)).length;
      if (matches < 2) return false;
      const rect = element.getBoundingClientRect();
      return rect.width >= 320 && rect.height >= 120;
    });

    const scored = candidates.map((element) => {
      const text = clean(element.textContent);
      const rect = element.getBoundingClientRect();
      let score = 0;
      if (text.includes('bestelling gereed')) score += 12;
      if (text.includes('pakketinformatie')) score += 9;
      if (text.includes('verzendgegevens')) score += 9;
      if (text.includes('vervoerder')) score += 8;
      if (text.includes('geleverd')) score += 6;
      score += Math.min(8, text.length / 80);
      score += rect.width > 520 ? 4 : 0;
      score -= getRectArea(element) / 1800000;
      return { element, score };
    }).sort((a, b) => b.score - a.score);

    let best = scored[0]?.element || null;
    if (!best) return null;

    let node = best;
    while (node.parentElement && node.parentElement !== main && node.parentElement !== card?.parentElement) {
      const parent = node.parentElement;
      if (parent.querySelector('input, textarea, select')) break;
      const parentText = clean(parent.textContent);
      const matchCount = keywords.filter((keyword) => parentText.includes(keyword)).length;
      const rect = parent.getBoundingClientRect();
      if (matchCount >= 2 && rect.width <= Math.min(window.innerWidth - 40, 900) && rect.height <= 1200) {
        node = parent;
      } else {
        break;
      }
    }
    return node;
  };

  const findNearestCardContainer = (element, root) => {
    let node = element;
    while (node && node !== root) {
      const parent = node.parentElement;
      if (!parent || parent === root) return node;
      if (parent.querySelectorAll('img, a').length > 8) return node;
      const rect = parent.getBoundingClientRect();
      if (rect.width > Math.min(window.innerWidth - 32, 760)) return node;
      node = parent;
    }
    return element;
  };

  const styleResultCards = (root) => {
    if (!root) return;
    root.classList.add('ew-track123-results');

    const all = [...root.querySelectorAll('*')];
    const orderIdNode = all.find((element) => /bestelling\s*:?\s*\d{5,}/i.test(element.textContent || ''));
    if (orderIdNode) orderIdNode.classList.add('ew-track123-results-orderid');

    const resultTitle = all.find((element) => {
      const text = clean(element.textContent);
      return text === 'bestelling gereed' || text === 'order ready' || text === 'delivered' || text === 'in transit';
    });
    if (resultTitle) {
      resultTitle.classList.add('ew-track123-results-title');
      const band = findNearestCardContainer(resultTitle, root);
      if (band && band !== root) band.classList.add('ew-track123-status-band');
    }

    const sectionKeywords = ['verzendgegevens', 'pakketinformatie', 'pakketinhoud', 'vervoerder'];
    const marked = new Set();
    all.forEach((element) => {
      const ownText = clean(element.textContent);
      if (!ownText || ownText.length > 60) return;
      if (!sectionKeywords.some((keyword) => ownText === keyword)) return;
      const container = findNearestCardContainer(element, root);
      if (container && container !== root && !marked.has(container)) {
        container.classList.add('ew-track123-result-card');
        marked.add(container);
      }
    });

    const directSections = [...root.children].filter((element) => {
      const rect = element.getBoundingClientRect();
      return rect.width > 140 && rect.height > 60;
    });

    if (directSections.length >= 2) {
      const gridCandidates = directSections.filter((element) => !element.classList.contains('ew-track123-status-band'));
      if (gridCandidates.length >= 2) {
        const grid = document.createElement('div');
        grid.className = 'ew-track123-result-grid';
        gridCandidates.forEach((element) => grid.appendChild(element));
        root.appendChild(grid);
      }
    }

    [...root.querySelectorAll('a')].forEach((link) => {
      if ((link.textContent || '').trim().length < 30) link.classList.add('ew-track123-highlight-link');
    });
  };

  const enhanceResults = (card) => {
    const resultRoot = findResultRoot(card);
    if (!resultRoot) return false;
    document.body.classList.add('ew-track123-has-results');
    if (!resultRoot.classList.contains('ew-track123-results')) {
      styleResultCards(resultRoot);
    }
    return true;
  };

  const createAftercare = () => {
    const section = document.createElement('section');
    section.className = 'ew-track123-aftercare';
    section.setAttribute('aria-label', i18n.aftercareAria);
    section.innerHTML = `
      <article class="ew-track123-aftercare-card">
        <strong>${i18n.noUpdateTitle}</strong>
        <p>${i18n.noUpdateText}</p>
      </article>
      <article class="ew-track123-aftercare-card">
        <strong>${i18n.deliveryTitle}</strong>
        <p>${i18n.deliveryText}</p>
        <a href="${storefrontUrl('pages/contact')}">${i18n.contact}</a>
      </article>
      <article class="ew-track123-aftercare-card">
        <strong>${i18n.receivedTitle}</strong>
        <p>${i18n.receivedText}</p>
        <a href="${storefrontUrl('pages/kenniscentrum')}">${i18n.knowledge}</a>
      </article>`;
    return section;
  };

  const enhance = () => {
    if (main.dataset.ewTrackEnhanced === 'true') return true;

    const card = findCard();
    if (!card) return false;

    const hero = findHero(card);
    if (!hero) return false;

    hero.classList.add('ew-track123-hero');
    markElements(card);

    let shell = card;
    while (shell.parentElement && shell.parentElement !== hero) shell = shell.parentElement;
    shell.classList.add('ew-track123-card-shell');

    let cleanupNode = shell;
    while (cleanupNode && cleanupNode !== hero) {
      if (cleanupNode !== card) {
        cleanupNode.classList.add('ew-track123-shell-reset');
        cleanupNode.style.setProperty('background', 'transparent', 'important');
        cleanupNode.style.setProperty('background-image', 'none', 'important');
      }
      cleanupNode = cleanupNode.parentElement;
    }

    if (!hero.querySelector(':scope > .ew-track123-intro')) {
      hero.insertBefore(createIntro(), hero.firstChild);
    }

    if (!main.querySelector('.ew-track123-aftercare')) {
      hero.insertAdjacentElement('afterend', createAftercare());
    }

    enhanceResults(card);

    main.dataset.ewTrackEnhanced = 'true';
    return true;
  };

  const observer = new MutationObserver(() => {
    const enhanced = enhance();
    const card = findCard();
    if (card) enhanceResults(card);
    if (enhanced && document.body.classList.contains('ew-track123-has-results')) {
      window.setTimeout(() => {
        const liveCard = findCard();
        if (liveCard) enhanceResults(liveCard);
      }, 250);
    }
  });

  observer.observe(main, { childList: true, subtree: true });
  enhance();
  window.setTimeout(() => {
    const liveCard = findCard();
    if (liveCard) enhanceResults(liveCard);
  }, 500);
  window.addEventListener('pagehide', () => observer.disconnect(), { once: true });
})();
